module.exports = __webpack_public_path__ + "../resources/img/bg_grid1_02.10b60342.png";